interface EyebrowBadgeProps {
  children?: React.ReactNode;
  className?: string;
}

export function EyebrowBadge({}: EyebrowBadgeProps) {
  return null;
}
